import React from 'react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import CloseIcon from '@atlaskit/icon/utility/migration/cross--editor-close';
import { Inline, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { WebhooksConfigurationLocation } from '../../common/types.tsx';
import messages from './messages.tsx';

type DesignUpdatesContentHeaderPops = {
	location: WebhooksConfigurationLocation;
	onClose?: () => void;
	isAdmin: boolean;
};

const DesignUpdatesContentHeader = ({
	location,
	onClose,
	isAdmin,
}: DesignUpdatesContentHeaderPops) => {
	const { formatMessage } = useIntl();
	return (
		<Inline spread="space-between" xcss={headerContainerStyles}>
			<Heading size="small">
				{formatMessage(isAdmin ? messages.copyForAdmin : messages.copy)}
			</Heading>
			{location === WebhooksConfigurationLocation.SECTION && (
				<Button
					appearance="subtle"
					iconBefore={<CloseIcon color="currentColor" label={formatMessage(messages.closeIcon)} />}
					onClick={onClose}
					interactionName="auto-generated.jira-issue-get-design-updates-content.ui.header.button"
				/>
			)}
		</Inline>
	);
};

const headerContainerStyles = xcss({
	gap: 'space.100',
});

export default DesignUpdatesContentHeader;
